import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorType } from '../../api/errorHandling';

interface IdentityState {
 accessToken?: string | null;
 refreshToken?: string | null;
 expiration?: number | null;
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
 error?: { [key: string]: ErrorType | null };
}

export const initialState: IdentityState = {
 accessToken: null,
 refreshToken: null,
 expiration: null,
 loading: {},
 success: {},
 error: {},
};

const identitySlice = createSlice({
 name: 'identity',
 initialState,
 reducers: {
  identityLoginStart(
   state,
   action: PayloadAction<{ email: string; password: string }>,
  ) {
   return {
    ...state,
    loading: { ...state.loading, identityLogin: true },
   };
  },
  identityLoginSuccess(state, action: PayloadAction<IdentityState>) {
   return {
    ...state,
    accessToken: action.payload.accessToken,
    refreshToken: action.payload.refreshToken,
    expiration: action.payload.expiration,
    success: { ...state.success, identityLogin: true },
    loading: { ...state.loading, identityLogin: null },
    error: { ...(state.error || {}), identityLogin: null },
   };
  },
  identityLoginFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, identityLogin: null },
    loading: { ...state.loading, identityLogin: null },
    error: { ...(state.error || {}), identityLogin: action.payload },
   };
  },
  identityLogoutStart(state) {
   return {
    ...state,
    loading: { ...state.loading, identityLogout: true },
   };
  },
  identityLogoutSuccess(state, action: PayloadAction<IdentityState>) {
   return {
    ...state,
    success: { ...state.success, identityLogout: true },
    loading: { ...state.loading, identityLogout: null },
   };
  },
  identityLogoutFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, identityLogout: null },
    loading: { ...state.loading, identityLogout: null },
    error: { ...(state.error || {}), identityLogout: action.payload },
   };
  },
 },
});
export const {
 identityLoginStart,
 identityLoginSuccess,
 identityLoginFailure,
 identityLogoutStart,
 identityLogoutSuccess,
 identityLogoutFailure,
} = identitySlice.actions;
export default identitySlice.reducer;
